import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { actions } from 'shared/actions/app';

import './index.scss';

interface Props {
  ideaId: number;
  ideaName: string;
}

type Enhanced = Props & InjectedTranslateProps & ReturnType<typeof mapDispatchToProps>;

const b = b_.with('idea-landing-authentication');

const mapDispatchToProps = (dispatch: Dispatch, { ideaId }: Props) => ({
  signup: () =>
    dispatch(
      actions.showAuthModal('signup', `investments/${ideaId}`, 'desktopInvestmentRegistration')
    ),
  signin: () =>
    dispatch(
      actions.showAuthModal('signin', `investments/${ideaId}`, 'desktopInvestmentRegistration')
    ),
});

const enhance = compose<Enhanced, Props>(translate, connect(undefined, mapDispatchToProps));

class Authentication extends React.Component<Enhanced> {
  render() {
    const { t, ideaName, signin, signup } = this.props;
    return (
      <div className={b()}>
        <button className={b('signup')} onClick={signup} data-testid="signup-btn">
          {t('Sign up')}
        </button>
        <button className={b('signin')} onClick={signin} data-testid="signin-btn">
          {t('Sign in')}
        </button>
        <p className={b('comment')}>
          {t('Please, login or register to invest to {{name}}', { name: ideaName })}
        </p>
      </div>
    );
  }
}

export default enhance(Authentication);
